import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import { Loading } from './../../common';
import { logout } from './../../../actions/AuthActions';

class LogOut extends Component {
	componentDidMount() {
		this.props._logout();
	}

	componentWillUnmount() {}

	handleModalClose() {
		return null;
	}

	_loading() {
		return null;
	}

	render() {
		if (!this.props.auth.signedIn) {
			return (
				<Redirect
					to={{
						pathname: '/',
						state: { from: '/login' },
					}}
				/>
			);
		}
		return <Loading />;
	}
}

const mapStateToProps = ({ auth }) => {
	return {
		auth,
	};
};

const mapDispatchToProps = dispatch => ({
	_logout: () => dispatch(logout()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(LogOut);



// WEBPACK FOOTER //
// ./src/components/screens/logout/LogOut.js